import React from "react";
import { AllTasksReportPdfDocument } from "./AllTasksReportPdfDocument";

function buildAllTaskReportFileName(filters) {
  const startPart = String(filters?.startDate || "start").trim();
  const endPart = String(filters?.endDate || "end").trim();
  const departmentPart = String(filters?.departmentName || "all-departments")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `all-task-report-${departmentPart || "all"}-${startPart}-${endPart}.pdf`;
}

function writeLoadingScreen(reportTab) {
  reportTab.document.write(`
    <html>
      <head>
        <title>Preparing PDF Report...</title>
        <style>
          body { margin: 0; font-family: Arial, sans-serif; background: #0f172a; color: #fff; display: grid; place-items: center; min-height: 100vh; }
          .card { max-width: 420px; padding: 32px; border-radius: 24px; background: rgba(255,255,255,0.08); box-shadow: 0 20px 50px rgba(15,23,42,0.35); }
          h1 { margin: 0 0 10px; font-size: 22px; }
          p { margin: 0; line-height: 1.6; color: #cbd5e1; }
        </style>
      </head>
      <body>
        <div class="card">
          <h1>Preparing PDF report</h1>
          <p>Your all task report is being generated and will open in this tab in a moment.</p>
        </div>
      </body>
    </html>
  `);
  reportTab.document.close();
}

export async function openAllTasksReportPdf({ companyInfo, filters, report, selectedColumns }) {
  const reportTab = typeof window !== "undefined" ? window.open("", "_blank") : null;

  if (!reportTab) {
    throw new Error("Unable to open report tab. Please allow pop-ups and try again.");
  }

  writeLoadingScreen(reportTab);

  try {
    const { Document, Page, StyleSheet, Text, View, Image, pdf } = await import("@react-pdf/renderer");
    const generatedAt = new Date().toISOString();
    const logoUrl = typeof window !== "undefined" ? `${window.location.origin}/light.png` : "/light.png";

    const reportBlob = await pdf(
      <AllTasksReportPdfDocument
        components={{ Document, Page, StyleSheet, Text, View, Image }}
        logoUrl={logoUrl}
        companyInfo={companyInfo}
        filters={filters}
        report={report}
        selectedColumns={selectedColumns}
        generatedAt={generatedAt}
      />
    ).toBlob();

    const reportUrl = URL.createObjectURL(reportBlob);
    reportTab.location.href = reportUrl;
    reportTab.document.title = buildAllTaskReportFileName(filters);

    setTimeout(() => URL.revokeObjectURL(reportUrl), 60_000);
  } catch (error) {
    reportTab.close();
    throw error;
  }
}
